// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store'
import VueBlu from 'vue-blu'
import vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'vue-blu/dist/css/vue-blu.min.css'
import './assets/scss/global.scss'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCBE8n8ob-amB9zM_Uo1uZ13TxclYFBCVs',
    libraries: 'places'
  }
})
Vue.use(VueBlu)
Vue.use(vuelidate)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  store
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js